module.exports = __webpack_public_path__ + "img/logo-tigo-money-small.2269174d.svg";